export function initSeoPositions() {
    document.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest('[data-export-seo-positions]')) return;
        var table = document.querySelector('.max-w-6xl table');
        if (!table) return;
        var headerCells = table.querySelectorAll('thead tr th');
        if (headerCells.length < 2) return;
        var dates = [];
        for (var i = 1; i < headerCells.length; i++) { dates.push(headerCells[i].textContent.trim()); }
        var lines = ['Фраза;Дата;Позиция;Показы;CTR;Клики'];
        var bodyRows = table.querySelectorAll('tbody tr');
        bodyRows.forEach(function (tr) {
            var phraseCell = tr.querySelector('th');
            if (!phraseCell) return;
            var phrase = phraseCell.textContent.trim().replace(/;/g, ',');
            var dataCells = tr.querySelectorAll('td');
            dataCells.forEach(function (td, idx) {
                var txt = td.textContent.trim();
                if (!txt || txt.indexOf('Нет данных') !== -1) return;
                var posMatch = txt.match(/Поз:\s*([0-9.,]+)/);
                var showsMatch = txt.match(/Пок:\s*([\d\s]+)/);
                var ctrMatch = txt.match(/CTR:\s*([0-9.,]+)/);
                var pos = posMatch ? posMatch[1].replace(',', '.') : '';
                var shows = showsMatch ? showsMatch[1].replace(/\s+/g, '') : '';
                var ctr = ctrMatch ? ctrMatch[1].replace(',', '.') : '';
                var dateLabel = dates[idx] || '';
                lines.push([phrase, dateLabel, pos, shows, ctr, ''].join(';'));
            });
        });
        if (lines.length <= 1) return;
        var blob = new Blob(['\ufeff' + lines.join('\n')], { type: 'text/csv;charset=utf-8' });
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'seo-positions-' + new Date().toISOString().slice(0, 10) + '.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);
    });
}
